<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure><i class="icon" v-bind:class="{'icon-icon_email':resource.support == 'email','icon-icon_sms':resource.support == 'sms'}"></i></figure>
                        <div>
                            <span class="breadcrumb">
                                Campagne <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                        <div class="notice-publication" v-bind:class="{'unactive':!resource.publication_state_id == 0, 'active':resource.publication_state_id == 1}">
                            <div v-if="!resource.publication_state_id">Cette campagne n'est pas active.</div>
                            <div v-if="resource.publication_state_id">Cette campagne est active !</div>
                            <div>
                              <form-publication-state v-model="resource.publication_state_id"></form-publication-state>
                            </div>
                        </div>
                    </header>

                    <main>

                         <languages :translations="resource.translations" :localesLoaded="localesLoaded" :locales="locales" v-model="locale"></languages>

                        <modal
                                v-model="modalValue"
                                v-show="isModalVisible"
                                @close="closeModal"
                                @validate="validateModal"/>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                                <form-text label="Slug" v-model="resource.slug" :required="true"></form-text>

                                <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                    <form-text :translate-key="'name'" :translations="resource.translations" :lang="client.id" :label="'Name'" v-model="resource.translations[client.id].name" :required="true"></form-text>
                                </div>
                                <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                    <form-text :translate-key="'description'" :translations="resource.translations" :lang="client.id" :label="'Description'" v-model="resource.translations[client.id].description"></form-text>
                                </div>

                                <form-text label="Token" v-model="resource.token" readonly="true" v-if="resource.token"></form-text>


                                <fieldset v-if="resource && resource.support == 'email'">
                                    <h3>Configuration Email</h3>
                                    <p class="headline"></p>

                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                        <form-text :translate-key="'email_subject'" :translations="resource.translations" :lang="client.id" :label="'Email subject'" v-model="resource.translations[client.id].email_subject" :required="true"></form-text>
                                    </div>
                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                        <form-text :translate-key="'email_name'" :translations="resource.translations" :lang="client.id" :label="'Email name'" v-model="resource.translations[client.id].email_name" :required="true"></form-text>
                                    </div>
                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                        <form-text :translate-key="'email'" :translations="resource.translations" :lang="client.id" :label="'Email'" v-model="resource.translations[client.id].email" :required="true"></form-text>
                                    </div>

                                </fieldset>

                                <fieldset v-if="localesLoaded && resource && resource.support == 'sms'">
                                  <h3>Configuration SMS</h3>
                                  <p class="headline"></p>

                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                        <form-text :lang="client.id" :label="'Phone name'" v-model="resource.translations[client.id].phone_name" :maxlength="10" :required="true"></form-text>
                                    </div>

                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                        <form-phone :lang="client.id" :label="'Phone number'" v-model="resource.translations[client.id].phone" :required="true"></form-phone>
                                    </div>

                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                        <form-textarea :lang="client.id" label="Message" v-model="resource.translations[client.id].template" maxlength="160" :required="true"></form-textarea>
                                    </div>

                                </fieldset>

                                <fieldset v-if="resource && resource.support == 'email'">
                                    <h3>Configuration Wallet</h3>
                                    <p class="headline"></p>

                                    <form-toggle label="Template PassSlot" v-model="resource.is_passslot"></form-toggle>

                                    <div v-if="resource.is_passslot">
                                        <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                            <form-text :translate-key="'template'" :translations="resource.translations" :lang="client.id" :label="'Template PassSlot'" v-model="resource.translations[client.id].passslot_template_id"></form-text>
                                        </div>
                                    </div>

                                </fieldset>


                            </tab>
                            <tab name="Publication">

                                <fieldset>
                                    <h3>Audience</h3>
                                  <p class="headline"></p>
                                    <div v-if="resource.audiences" class="audience-contacts-info">
                                        <span>Audience touchée</span>
                                        <strong>{{ totalAudience }} personne(s)</strong>
                                    </div>

                                    <!-- SUPPORT -->
                                    <div class="form-field form-audiences" v-if="resource.audiences">
                                        <div class="form-label">
                                            <label>Audiences</label>
                                        </div>
                                        <div class="form-input">
                                            <div class="form-input-wrapper">

                                                <label @click="updateAudience(item.id)" v-bind:class="{'active':resource.audiences.indexOf(item.id) >= 0}" v-for="item in audiences">
                                                    <div>
                                                        <i class="icon icon-icon_users"></i>
                                                    </div>
                                                    <div style="flex:1;">
                                                        <strong>{{ item.name }}</strong>
                                                        <p>{{ item.description }}</p>
                                                    </div>
                                                    <div>
                                                        {{ item.count }} personne(s)
                                                    </div>
                                                </label>

                                            </div>
                                        </div>
                                    </div>

                                </fieldset>

                                <!-- -->

                                <fieldset>
                                    <h3>Publication</h3>
                                  <p class="headline"></p>

                                    <form-toggle label="Réccurence" v-model="resource.recurrence"></form-toggle>


                                    <form-datex label="Date d'envoi" v-model="resource.schedule_date" :hide-time="false" time="09:00:00" v-if="!resource.recurrence"></form-datex>


                                    <div class="form-field form-schedule" v-if="resource.recurrence">
                                        <div class="form-label">
                                            <label>Planification</label>
                                        </div>
                                        <div class="form-input">
                                            <div class="form-input-wrapper">

                                                <div>
                                                    <strong>Jours</strong>
                                                    <label v-for="item in week_days"><input type="checkbox" :value="item" v-model="resource.recurrence_week_days"/> {{ week_days_label[item] }}</label>
                                                </div>

                                                <div>
                                                    <strong>Mois</strong>
                                                    <label v-for="item in months"><input type="checkbox" :value="item" v-model="resource.recurrence_months"/> {{ months_label[item-1] }}</label>
                                                </div>

                                                <div>
                                                    <strong>Jours</strong>
                                                    <div>
                                                        <label v-for="item in days"><input type="checkbox" :value="item" v-model="resource.recurrence_days"/> {{ item }}</label>
                                                    </div>
                                                </div>

                                                <div>
                                                    <strong>Heures</strong>
                                                    <div>
                                                        <label v-for="item in hours"><input type="checkbox" :value="item" v-model="resource.recurrence_hours"/> {{ item }}</label>
                                                    </div>
                                                </div>

                                                <div>
                                                    <strong>Minutes</strong>
                                                    <div>
                                                        <label v-for="item in minutes"><input type="checkbox" :value="item" v-model="resource.recurrence_minutes"/> {{ item }}</label>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </fieldset>

                            </tab>
                            <tab name="Template" v-if="resource && resource.support == 'email'">

                                <form-toggle label="Template blade" v-model="resource.is_template_blade"></form-toggle>

                                <div v-if="resource.is_template_blade">
                                    <div v-for="client in locales" v-show="client.id == locale || locale == 'all'" v-if="localesLoaded">
                                        <form-text :lang="client.id" :label="'Template blade'" v-model="resource.translations[client.id].template_blade"></form-text>
                                    </div>
                                </div>

                                <div v-if="!resource.is_template_blade">

                                    <form-editor
                                            :lang="locale"
                                            label="Template"
                                            v-model="resource.translations"
                                            language="html"
                                            :required="true"
                                            :medias="resource.medias"
                                            @updateEvent="updateMedias"></form-editor>

                                </div>

                            </tab>
                            <tab name="Paramètres UTM">

                                <form-text label="Campaign source" v-model="resource.utm_source" required="true"></form-text>
                                <form-text label="Campaign medium" v-model="resource.utm_medium"></form-text>
                                <form-text label="Campaign name" v-model="resource.utm_campaign"></form-text>
                                <form-text label="Campaign term" v-model="resource.utm_term"></form-text>
                                <form-text label="Campaign term" v-model="resource.utm_content"></form-text>

                            </tab>
                            <!--
                            <tab name="Passes">


                                <div v-if="resource.passes">

                                    <div class="datagrid">
                                        <div class="datagrid-header">
                                            <div>
                                                <div></div>
                                                <div class="center">Person details</div>
                                                <div class="center">Email</div>
                                                <div class="center">Date</div>
                                                <div></div>
                                            </div>
                                        </div>
                                        <div class="datagrid-body">
                                            <div v-for="item in resource.passes">
                                                <div></div>
                                                <div><strong>{{ item.values.firstname }} {{ item.values.lastname }}</strong></div>
                                                <div>{{ item.values.email }}</div>
                                                <div>{{ item.status }}</div>
                                                <div>{{ item.created_at }}</div>
                                                <div></div>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </tab>
                            -->
                        </tabs>

                    </main>

                    <footer>
                        <div>

                        </div>
                        <div>
                            <button @click="send()"><span>Envoi test</span></button>
                        </div>
                    </footer>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import AudienceService from '../audience/AudienceService.js';
    import CampaignService from './CampaignService.js';
    import Edit from '../../../layouts/Edit.vue';

    import Modal from './Modal.vue'

    export default {
        extends: Edit,
        components: {
            Modal
        },
        data () {
            return {
                audiences: [],
                totalAudience: 0,
                isModalVisible: false,
                modalValue: {},
                week_days: [0,1,2,3,4,5,6],
                week_days_label: ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'],
                months: [1,2,3,4,5,6,7,8,9,10,11,12],
                months_label: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Aout','Septembre','Octobre','Novembre','Décembre'],
                days: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31],
                hours: [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23],
                minutes: [0,5,10,15,20,25,30,35,40,45,50,55],
            }
        },
        mounted: function(){

            AudienceService.all().then(response => {
                this.audiences = response.data
                this.isLoading = false
                /*
                for(let item of response.data){
                    if( !item.parent_id && item.id != this.resource.id ){
                        this.attributes.push(item)
                    }
                }*/

            })

        },
        methods:{
            resourceLoaded: function(){
                this.setTranslations(['name','description','email_subject','email_name','email','phone_name','phone','template','template_blade','passslot_template_id']);

                this.resource.audiences = this.resource.audiences ? this.resource.audiences : []
                this.resource.type = this.resource.type ? this.resource.type : "newsletter"
                this.resource.support = this.resource.support ? this.resource.support : this.$route.params.support
                this.resource.recurrence_week_days = this.resource.recurrence_week_days ? this.resource.recurrence_week_days.split(',') : []
                this.resource.recurrence_months = this.resource.recurrence_months ? this.resource.recurrence_months.split(',') : []
                this.resource.recurrence_days = this.resource.recurrence_days ? this.resource.recurrence_days.split(',') : []
                this.resource.recurrence_hours = this.resource.recurrence_hours ? this.resource.recurrence_hours.split(',') : []
                this.resource.recurrence_minutes = this.resource.recurrence_minutes ? this.resource.recurrence_minutes.split(',') : []

                let audiences = [];
                if( this.resource.audiences ){
                    for(let item of this.resource.audiences){
                        audiences.push(item.id);
                    }
                }
                this.resource.audiences = audiences
                this.updateAudience()
                this.initialize()
            },
            beforeUpdate: function(Resource){

                return true;
            },
            getResource: function(){
                return CampaignService
            },
            selectType: function(str){
                this.resource.type = str
                this.$forceUpdate()
            },
            selectSupport: function(str){
                this.resource.support = str
                this.$forceUpdate()
            },
            updateMedias: function(variable) {
                this.resource.medias = variable
            },
            updateAudience: function(id){
                if( id ){
                    if( this.resource.audiences.indexOf(id) >= 0 ){
                        this.resource.audiences.splice(this.resource.audiences.indexOf(id), 1)
                    }else{
                        this.resource.audiences.push(id)
                    }
                }

                this.totalAudience = 0
                for(let item of this.audiences){
                    if( this.resource.audiences.indexOf(item.id) >= 0 ){
                        this.totalAudience += item.count
                    }
                }
                this.$forceUpdate()
            },
            closeModal() {
                this.isModalVisible = false;
            },
            validateModal() {

                let to = this.resource.support == 'email' ? this.modalValue.email : this.modalValue.phone

                CampaignService.sendbox({id:this.resource.id, to:to}).then(response => {
                    this.closeModal()
                })

            },
            send: function(){

                if( !this.beforeUpdate(this.resource) ){
                    return false;
                }

                this.getResource().update(this.resource.id, this.resource).then((response) => {

                    this.isModalVisible = true;
                    this.modalValue.email = this.$store.state.user.person.email
                    this.modalValue.phone = this.$store.state.user.person.phone_mobile
                    this.modalValue.support = this.resource.support

                })

            }
        },
        watch: {
            'resource': {
                handler: function(newVal, oldVal) {
                    this.$forceUpdate()
                },
                deep: true
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/campaign/campaign/Edit.vue